import { ThemeColors } from '~/themes/colors'

interface NotificationBadgeVariantColors {
  Background: ThemeColors
  FontColor: ThemeColors
}

export interface NotificationBadgeColors {
  Notification: NotificationBadgeVariantColors
  Info: NotificationBadgeVariantColors
  FilterHover: NotificationBadgeVariantColors
  Popup: NotificationBadgeVariantColors
  New: NotificationBadgeVariantColors
  Beta: NotificationBadgeVariantColors
}

export const NotificationBadgeColors: NotificationBadgeColors = {
  Notification: {
    Background: {
      default: 'blue.700',
    },
    FontColor: {
      default: 'white',
    },
  },
  Info: {
    Background: {
      default: 'gray.1300',
    },
    FontColor: {
      default: 'white',
    },
  },
  FilterHover: {
    Background: {
      default: 'blue.900',
    },
    FontColor: {
      default: 'white',
    },
  },
  Popup: {
    Background: {
      default: 'gradients.mangoBrand.button',
    },
    FontColor: {
      default: 'white',
    },
  },
  New: {
    Background: {
      default: 'green.700',
    },
    FontColor: {
      default: 'white',
    },
  },
  Beta: {
    Background: {
      default: 'mango.orange',
    },
    FontColor: {
      default: 'white',
    },
  },
}
